var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"acadomia-env",attrs:{"id":"app"}},[_c('FormScreen',{attrs:{"landingName":_vm.landingName,"defaultPrefilledModel":_vm.prefilledModel},on:{"message":_vm.handleMessage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }